import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";

const AdBanner = ({ adData, position = 0 }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 600);
      setIsTablet(width > 600 && width <= 960);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get the ad for this position (fallback to first ad if position not available)
  const ad = adData?.[position] || (position === 0 ? adData?.[0] : null);
  if (!ad) return null;

  const getImageUrl = () => {
    if (isMobile && ad.mobile_media?.[0]?.url) {
      return ad.mobile_media[0].url;
    }
    if (isTablet && ad.tablet_media?.[0]?.url) {
      return ad.tablet_media[0].url;
    }
    return ad.desktop_media?.[0]?.url;
  };

  const imageUrl = getImageUrl();
  if (!imageUrl) return null;

  return (
    <Box sx={{ py: { xs: 2, md: 3 }, backgroundColor: "#fff" }}>
      <Container maxWidth="xl">
        <Typography
          sx={{
            fontSize: "11px",
            color: "#999",
            textAlign: "right",
            mb: 0.5,
          }}
        >
          Advertisement
        </Typography>
        <Box
          sx={{
            width: "100%",
            height: { xs: "150px", sm: "180px", md: "200px" },
            borderRadius: "12px",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Box
            component="img"
            src={imageUrl}
            alt={ad.advertiser_name || "Advertisement"}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default AdBanner;
